import { useMutation } from '@tanstack/react-query';

import type {
  AttachBookingReservationData,
  BookingReservationMutationResponse,
  CancelBookingReservationData,
  CreateBookingReservationData,
  MarkMissedBookingReservationData,
  UpdateMissedCommentBookingReservationData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateBookingReservationMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CreateBookingReservationData }) =>
      HttpClient.request<BookingReservationMutationResponse>({
        method: 'POST',
        url: params.url,
        data: { reservation: params.data },
      }),
  });

export const useAttachBookingReservationMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: AttachBookingReservationData }) =>
      HttpClient.request<BookingReservationMutationResponse>({
        method: 'PUT',
        url: `${params.url}/attach`,
        data: { reservation: params.data },
      }),
  });

export const useCancelBookingReservationMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CancelBookingReservationData }) =>
      HttpClient.request<BookingReservationMutationResponse>({
        method: 'PUT',
        url: `${params.url}/cancel`,
        data: { reservation: params.data },
      }),
  });

export const useMarkMissedBookingReservationMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: MarkMissedBookingReservationData;
    }) =>
      HttpClient.request<BookingReservationMutationResponse>({
        method: 'POST',
        url: `${params.url}/missed_mark`,
        data: { reservation: params.data },
      }),
  });

export const useUpdateMissedCommentBookingReservationMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: UpdateMissedCommentBookingReservationData;
    }) =>
      HttpClient.request<BookingReservationMutationResponse>({
        method: 'PUT',
        url: `${params.url}/missed_mark`,
        data: { reservation: params.data },
      }),
  });
